<template>
  <Catalog
    title="Источник лида"
    name-label="Название источника"
    submit-error="Укажите название источника лида."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "LeadStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getLeadSourceById(id);
    },
    async putData(data) {
      return await this.putLeadSource(data)
    },
    async postData(data) {
      return await this.postLeadSource(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LeadSources/LeadSource.vue